import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";
export function subRemoteWorkReducer() {
    return combineReducers({
        RemoteWorkPO_ListSubForPO_Tree: createItemReducer('SubRemoteWork', 'RemoteWorkPO.ListSubForPO_Tree', false),
        RemoteWorkPO_ListSubForPO_Tree_Params: createItemReducerParams("SubRemoteWork", 'RemoteWorkPO.ListSubForPO_Tree'),
        /*
                dataItem_List: createItemReducer('SubRemoteWork', 'RemoteWorkPO.ListSubForPO', false),
                dataItem_List_Params: createItemReducerParams("SubRemoteWork", "RemoteWorkPO.ListSubForPO"),
        */
        RemoteWorkPO_FiltersForPO: createItemReducer("SubRemoteWork", "RemoteWorkPO.FiltersForPO", false),
        //dataItem_Tree: createItemReducer('SubRemoteWork', 'RemoteWorkPO.ListSubForPO_Tree', false),
        RemoteWorkHardwareSet_ListForPO: createItemReducer("SubRemoteWork", "RemoteWorkHardwareSet.ListForPO", false),
        RemoteWorkHardwareSet_ListHWSetForPO: createItemReducer("SubRemoteWork", "RemoteWorkHardwareSet.ListHWSetForPO", false),
        RemoteWorkHardwareSet_GetButtonForPO: createItemReducer("SubRemoteWork", "RemoteWorkHardwareSet.GetButtonForPO", false),
        RemoteWorkHardwareSet_ListSRForPO: createItemReducer("SubRemoteWork", "RemoteWorkHardwareSet.ListSRForPO", false),
        RemoteWorkClaim_SendToEDO: createItemReducer("SubRemoteWork", "RemoteWorkClaim.SendToEDO", false),
    });
}